// 25/10/2023 marco molina
//const {obj}    = require ('./click-obj')
const { obj } = require('./click-components')
const { obj_entity } = require('./click-components-entity')
const snack = require('../components/snack/snack')
const settings = require('../js-handler/settings')
const pageMap = require('../applications/staff/desktop/staff-page-map')

document.body.addEventListener('click', function (ev) {// console.log('click>', ev.detail)  
    //avoid duble click
    if (!(!ev.detail || ev.detail == 1)) { return }

    // console.log('click>', ev.detail ) 

    analice(ev)
    ev.stopPropagation()

}, true)


function analice(ev) {  // console.log('click analice>', ev.target)

    const detail = getDetail(ev)
    //console.log('click analice>',detail)

    if (cancel(detail)) { return }

    const verify = verifyPermission(ev)
    if (!verify) { snack.start({ act: 'show', id: 'noAccess', }); return }

    detail.click.forEach((detailSplited) => {
        start(detailSplited, ev)
    })

}/**/

export function start(detail, ev) {  //console.log('clickx>', detail)  

    // console.log(verify)
    // 25/10/2023 marco molina se cambio el tipo const por la variable let
    let elem = obj[detail.dest] //#######HERE
    detail.ev = ev

    //buscar en click-obj
    if (elem != undefined) {
        elem.start(detail)
        return
    }

    // 25/10/2023 marco molina
    //buscar en click-obj-entity
    elem = obj_entity[detail.dest];
    if (elem != undefined) {
        elem.start(detail)
        return
    }


    snack.start({ act: 'show', id: 'clickError', })

}/**/

//get html data-detail
function getDetail(ev) {

    return JSON.parse(ev.target.getAttribute('data-detail'))
}

//return true to cancel click process
function cancel(detail) {

    if (detail === null || detail === undefined || detail === "") { return true }
    if (detail.click === null || detail.click === undefined || detail.click === "") { return true }

    return false
}

function verifyPermission(ev) {
    const settingsData = settings.getData();
    if (!settingsData || settingsData.right !== 'user') {
        return true;
    }

    let access = false;
    const entitiesPermission = settingsData.leftnav

    if (!ev.target.classList.contains('pageLink')) {
        const entity = ev.target.id.split('-')[1]
        // console.log(entitiesPermission)
        // console.log('redirect a entidad con permisos')
        // console.log(pageMap)
        entitiesPermission.forEach(i => {
            if (i.entity === entity) {
                // console.log(i)
                if (i.privilegeDB === "readWrite") {
                    access = true;
                    return access
                }
            }
        });

        const parentPages = Object.values(pageMap).filter((i) => i.parentPage === entity)
        const destList = parentPages.map((item) => item.click.dest);

        const firstEntityWithPermission = entitiesPermission.find((i) =>
            destList.includes(i.entity) &&
            (i.privilegeDB !== "none" || i.privilegeFile !== "none" || i.privilegeAgrmt !== "none")
        );

        if (firstEntityWithPermission) {
            access = true
            return access
        }

        return true

    }

    const entityPage = ev.target.classList[3].split('-')

    entitiesPermission.forEach(i => {
        if (i.entity === entityPage[0]) {
            // console.log(i)
            if (i.privilegeDB === "readWrite") {
                access = true;
            }
        }
    });

    return access;

}

function swichtPage() {

}
//const backControl  = require ('./backControl')
//entities
//activate on first click only to avoid hiding again on multiple clicks
// code here. // It will execute only once on multiple clicks
// if(!(!ev.detail || ev.detail == 1) ){ return }

